import { Widget } from "./baseWidget";
import { CommonConfig } from "./commonWidgetProps";
import { TextFormatting } from './textFormat'


export class TextInput extends Widget {
  type = 'input';
  gridX = 6
  minGridX = 4

  config = {
    // hidden: false,
    // editable: true,
    props: [
      'floatLabel',
      'appearance',
      'prefix',
      'suffix'
    ],
    appearance: {
      displayName: "Input appearance",
      value: "standard",
      type: "select"
    },
    floatLabel: {
      displayName: 'Floating label',
      type: 'radio',
      value: 'auto',
      valueOptions: ['auto','always'],
    },
    prefix: {
      displayName: 'Prefix',
      type: 'text',
      value: '',
    },
    suffix: {
      displayName: 'Suffix',
      type: 'text',
      value: '',
    },

    // appearance: {
    //   displayName: 'Appearance',
    //   value: 'default',
    //   type: 'select',
    //   options: ['default', 'rounded', 'outlined']
    // }
    supportedValidators: ['email','minlength','maxlength','url','regex','contains']
  }
  textFormat = undefined;

  constructor(id: number, name: string) {
    super(id, name)

    this.attachCommonConfig(this)
    this.config['placeholder'].value = 'Enter your text here';
    this.textFormat = TextFormatting.initStyles(JSON.parse(JSON.stringify(TextFormatting.textFormatting())))
  }

  public getMappingConfig() {
    let map = {
      __id: "${panel.id}.${widget.id}.value",
      name: "${panel.name} ${widget.name}",
      dataType: "string"
    }
    return map;
  }

  public getWidgetConfig() {
    let map: any = {
      valuePath: "config.value.value",
      effect: {
        styles: []
      }
    }
    map = this.mergeEffectStyle(map);

    const appearance = this.config.appearance.value;
    if (appearance === 'rounded') {
      map.effect.styles.push('rounded');
    } else if (appearance === 'outlined') {
      map.effect.styles.push('outlined');
    }

    return map;
  }
}
